import { useEffect, useState } from "react";
import PropTypes from "prop-types";

// @mui material components
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDInput from "components/MDInput";

import { diaChiApi } from "api/diaChi";

// Cặp dropdown Tỉnh/Thành phố -> Xã/Phường, xã lọc theo tỉnh đã chọn.
// Dùng chung cho form Chủ vườn và Vườn. onChange trả kèm tinhMa/xaMa (mã
// hành chính nhà nước) để nơi cần (vd sinh Mã chủ vườn) dùng được luôn,
// không phải tra cứu lại theo tên.
function ChonDiaChi({ tinh, xa, onChange, batBuoc, disabled }) {
  const [tinhList, setTinhList] = useState([]);
  const [xaList, setXaList] = useState([]);
  const [dangTaiXa, setDangTaiXa] = useState(false);

  useEffect(() => {
    diaChiApi.danhSachTinh().then(setTinhList);
  }, []);

  useEffect(() => {
    const tinhObj = tinhList.find((t) => t.name === tinh);
    if (!tinhObj) {
      setXaList([]);
      return;
    }
    setDangTaiXa(true);
    diaChiApi
      .danhSachXa(tinhObj.code)
      .then(setXaList)
      .finally(() => setDangTaiXa(false));
  }, [tinh, tinhList]);

  return (
    <>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          options={tinhList}
          getOptionLabel={(o) => o.name ?? ""}
          isOptionEqualToValue={(o, v) => o.code === v.code}
          value={tinhList.find((t) => t.name === tinh) ?? null}
          onChange={(_, val) =>
            onChange({
              tinh: val?.name ?? "",
              tinhMa: val?.code != null ? String(val.code) : "",
              xa: "",
              xaMa: "",
            })
          }
          disabled={disabled}
          renderInput={(params) => (
            <MDInput {...params} label="Tỉnh/Thành phố" required={batBuoc} fullWidth />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          options={xaList}
          getOptionLabel={(o) => o.name ?? ""}
          isOptionEqualToValue={(o, v) => o.code === v.code}
          value={xaList.find((x) => x.name === xa) ?? null}
          onChange={(_, val) =>
            onChange({
              tinh,
              tinhMa: String(tinhList.find((t) => t.name === tinh)?.code ?? ""),
              xa: val?.name ?? "",
              xaMa: val?.code != null ? String(val.code) : "",
            })
          }
          disabled={disabled}
          loading={dangTaiXa}
          renderInput={(params) => (
            <MDInput {...params} label="Xã/Phường" required={batBuoc} fullWidth />
          )}
        />
      </Grid>
    </>
  );
}

ChonDiaChi.defaultProps = {
  tinh: "",
  xa: "",
  batBuoc: false,
  disabled: false,
};

ChonDiaChi.propTypes = {
  tinh: PropTypes.string,
  xa: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  batBuoc: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ChonDiaChi;
